import EditComposerModal from 'components/modal/EditComposerModal';
import { useAuth } from 'hooks/auth';
import axios from 'lib/axios';
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
function ProposeComposer() {
    const { user, isFetchingUser } = useAuth();
    const [openEditComposerModal, setOpenEditComposerModal] = useState(false)
    const [itemToEdit, setItemToEdit] = useState(null)
    const params = useParams()

    const fetchItemToEdit = (id) => {
        axios.get(`/show-composer/${id}`).then((res) => {
            setItemToEdit(res.data.data);
            const work = res?.data?.data
            setOpenEditComposerModal(true);
            console.log('itemToEdit :>> ', itemToEdit);
        }).catch(() => { })
    }

    useEffect(() => {
        if (!isFetchingUser && !user) {
            window.location.pathname = `/auth/login/url=${'test'}`;
        }
    }, [user])

    useEffect(() => {
        if (!isFetchingUser && user && !itemToEdit) {
            fetchItemToEdit(params?.id);
        }
    }, [isFetchingUser])

    return (
        <>
            {itemToEdit && <EditComposerModal
                open={openEditComposerModal}
                setOpen={setOpenEditComposerModal}
                composerToEdit={itemToEdit}
                onClose={() => setOpenEditComposerModal(false)}
            >
            </EditComposerModal>}</>
    )
}

export default ProposeComposer